import { render, staticRenderFns } from "./pointOrderList.vue?vue&type=template&id=26ffdfca&"
import script from "./pointOrderList.vue?vue&type=script&lang=js&"
export * from "./pointOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports